import { Extension } from '@tiptap/core';
export const DisableEnter = Extension.create({
    addKeyboardShortcuts() {
        return {
            Enter: () => true,
        };
    },
});
//# sourceMappingURL=extentions.js.map